import React, { useEffect, useState } from 'react'
import { raiseSupportTicket } from '../../common/allApi'
import { toast, ToastContainer } from 'react-toastify'
import { Box } from '@chakra-ui/react'
import IframeSupport from './iframeSupport'
import Navbar from '../SharePages/Navbar/Navbar'
import SideNavBar from '../SharePages/SideNavBar/SideNavBar'
import Footer from '../SharePages/Footer/Footer'

const NewSupport = () => {

  const [suportShow, setSupportShow] = useState(false)
  const [isSupportLinkLoading, setisSupportLinkLoading] = useState(false)
  const [iframeData, setiframeData] = useState()
  const handelRaiseSupport = async () => {
    try {
      setSupportShow(true)
      setisSupportLinkLoading(true)
      const response = await raiseSupportTicket("List");
      if (response?.data?.isSuccess) {
        setisSupportLinkLoading(false)
        setiframeData(response?.data?.data?.redirectUrl)
        // window.open(response?.data?.data?.redirectUrl, "_blank");
      }
    } catch (error) {
      setisSupportLinkLoading(false)
      toast.error("Please try again.");
    }
  };

  useEffect(() => {
    handelRaiseSupport()
  }, [])
  return (
    <div>
      <Navbar></Navbar>
      <SideNavBar></SideNavBar>
      <ToastContainer position="bottom-right" autoClose={1500} />
      <div className="content-wrapper search-panel-bg">
        {suportShow &&
          <>
            <section className="content " >
              <div className="container-fluid py-5">
                <div className="card box-shadow rounded p-3">

                  <Box display={'flex'} justifyContent={'space-between'} >
                    <p className="font-semibold">Support</p>


                  </Box>
                  <hr style={{ marginTop: '2px' }} />

                  <IframeSupport isSupportLinkLoading={isSupportLinkLoading} iframeData={iframeData} setisSupportLinkLoading={setisSupportLinkLoading} />
                </div>
              </div>

            </section>
          </>}
      </div>
      <Footer></Footer>
    </div>
  )
}

export default NewSupport